module.exports = __webpack_public_path__ + "assets/img/logo.91d309501102bc1fe7a162a658b726e1.png";